export default __webpack_public_path__ + "static/media/rs_doc_icon.ad06e757.svg";